import React from "react";
import { Link } from "@reach/router";
import Constants from "../constants/Constants";
const NavLink = (props) => (
  <Link
    {...props}
    getProps={({ isCurrent }) => {
      // the object returned here is passed to the
      // anchor element's props
      return {
        className: isCurrent ? "active" : "",
      };
    }}
  />
);
const Navigation = ({ unreadMsgs }) => {
  return (
    <div className="navigation_sticky">
      <div className="flex">
        <div className="item">
          <NavLink to={`${Constants.MA}favorites`} className="button_like">
            <i className="icon-empty-heart" />
          </NavLink>
        </div>
        <div className="item">
          <NavLink to={`${Constants.MA}friends`}>
            <i className="icon-models" />
          </NavLink>
        </div>
        <div className="item">
          <NavLink to={`${Constants.MA}messages`}>
            <i className="icon-email" />
            {unreadMsgs > 0 ? <div className="unread">{unreadMsgs}</div> : null}
          </NavLink>
        </div>
        <div className="item">
          <NavLink to={`${Constants.MA}subscriptions`}>
            <i className="icon-fav" />
          </NavLink>
        </div>
        <div className="item">
          <NavLink to={`${Constants.MA}profile`}>
            <i className="icon-user" />
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
